var Theme;
(function (Theme) {
  Theme.getLight = function () {
    return {
      buttonSwitchContainerBg: '$02dp',
      buttonSwitchActiveBg: '$primary',
      buttonSwitchOffBg: 'transparent',
      buttonSwitchOffColor: '$hiContrast',
      buttonSwitchActiveColor: 'white'
    };
  };
  Theme.getDark = function () {
    return {
      buttonSwitchContainerBg: '$02dp',
      buttonSwitchActiveBg: '$primary',
      buttonSwitchOffBg: 'transparent',
      buttonSwitchOffColor: '$hiContrast',
      buttonSwitchActiveColor: '$deepBlue2'
    };
  };
})(Theme || (Theme = {}));

export { Theme };
